import { message } from 'antd'
import dayjs from 'dayjs'
import imageUtil from './imageUtil'

export const WeekDay = ["日", "一", "二", "三", "四", "五", "六"]

export const toPage = (url) => {
  window.location.href = url
}

export const checkMobile = (phone, showMsg = true) => {
  const MobileReg = /^1[3456789]\d{9}$/;
  if (!MobileReg.test(phone)) {
    showMsg && message.error('请输入正确的手机号')
    return false
  }
  return true
}

export function getRouterQuery() {
  let url = window.location.search //获取url中"?"符后的字串
  let queryArr: any = {}
  if (url.indexOf('?') != -1) {
    try {
      url = decodeURIComponent(url)
      let str = url.substr(1)
      let arr = str.split('&')
      for (let i = 0; i < arr.length; i++) {
        let a = arr[i].split('=')
        queryArr[a[0]] = unescape(arr[i].split('=')[1])
      }
    } catch (error) {
      console.log('getRouterQuery errored', error)
    }
  }
  return queryArr
}

export const suportWebp = () => {
  if (typeof window === 'undefined') {
    return
  }
  const localRes = localStorage.getItem('supportsWebp')
  if (localRes === 'support') {
    window.CLOUDCHECK = window.CLOUDCHECK || {
      isWebpAvailable: true,
    }
    return
  }
  window.CLOUDCHECK = window.CLOUDCHECK || {}
  imageUtil.caniuseWebp((res: boolean) => {
    window.CLOUDCHECK.isWebpAvailable = res
    if (res) {
      localStorage.setItem('supportsWebp', 'support')
    } else {
      document.documentElement.removeAttribute('webp')
    }
  }, 'lossy')
}

export const formatTime = (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss')

// 内地身份证正则
const MainLandIdReg = /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/
// 香港、台湾、澳门身份证校验
const HongKongIdReg = /^[a-zA-Z]\d{6}\([\dA]\)$/
const MacaoIdReg = /^[1|5|7]\d{6}\(\d\)$/
const TaiWanIdReg = /^[a-zA-Z][0-9]{9}$/
export const checkIdNumber = (idNumber) => {
  return MainLandIdReg.test(idNumber) || HongKongIdReg.test(idNumber) || MacaoIdReg.test(idNumber) || TaiWanIdReg.test(idNumber)
}

const EmailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const checkEmail = (email) => {
  return EmailReg.test(email)
}

export const downloadFile = (fileUrl, fileName) => {
  const $a = document.createElement('a')
  $a.href = fileUrl
  $a.download = fileName
  $a.click()
}
